import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ROUTE_REGISTRATION_WIZARD } from '../app.constants';
import { UserStore } from '../store/user/user.store';
import { firstValueFrom, of } from 'rxjs';
import { filter, timeout } from 'rxjs/operators';

async function checkUserStatus() {
  const userStore = inject(UserStore);
  const router = inject(Router);

  /**
   * Waits for the `userStore.isInitialized$` observable to emit a truthy value or times out after 30 seconds.
   */
  const isUserStoreInitializedAfter30sec = await firstValueFrom(
    userStore.isInitialized$.pipe(filter(Boolean), timeout({ each: 30000, with: () => of(false) })),
  );

  if (!isUserStoreInitializedAfter30sec) {
    // eslint-disable-next-line sonarjs/todo-tag
    //TODO: Should be handled bei global critical error handling in the future
    return false;
  }
  if (!userStore.isActive()) {
    return router.createUrlTree([ROUTE_REGISTRATION_WIZARD]);
  } else {
    return true;
  }
}

export const userStatusGuard: CanActivateFn = checkUserStatus;
